// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 1761 ? "d0deef33" : chunkId) + "." + {"1761":"1fe3afdf5d5ad41b","5603":"6370b4db4c52ec4e"}[chunkId] + ".js";
};